import { RootState } from '../../store';

export const selectUserManagementState = (state: RootState) =>
  state.userManagementSlice;
